/**
 * Donation frequency types.
 */
export enum DonationFrequency {
  OneTime = 'one-time',
  Reoccurring = 'reoccurring',
}
